import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.3.1_next@15.5.19_@opentelemetry+api@1.9.1_react-dom@19.2.7_react@19._qnm4qvdhqud6qosrtucsqvuj7a/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
